import Cookies from 'universal-cookie';
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { UserOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { Row, Col, Dropdown, Space, notification, Avatar } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { profilemenu } from "../../dropdownmenus/profileactions";
import patreon_img from "../../login_with_patreon.png";
import logo_img from "src/assets/img/svg/logo.svg";
import rss_icon from "src/assets/img/svg/RSS_Feed.svg";
import {
  HeaderSection,
  LogoContainer,
  NotHidden,
  CustomNavLinkSmall,
  NavFlexContainer,
  PatreonButon,
  MobileMenuWrapper,
  MobileNavButton,
  MobileNavExternal,
  MobileSplitRow,
  MobileSplitButton,
  ScrollTopButton,
  RSSLink,
  LogoAndRSSWrapper,
  DesktopRSSWrapper,
  MobileRSSWrapper,
} from "./styles";
import axiosRetry from 'axios-retry';
import rillmentConfig from "./../../config";
const axios = require('axios').default;
const { HashLink: Link } = require("react-router-hash-link");

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => retryCount * 500,
  retryCondition: (e) => { return axiosRetry.isNetworkOrIdempotentRequestError(e) || e?.response?.status === 429 }
});

const cookies = new Cookies();

const useLocationChange = (action: any) => {
  const location = useLocation();
  React.useEffect(() => { action(location); }, [location]);
}

const Header: React.FC = () => {
  const location = useLocation();
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [needClientActivation, setNeedClientActivation] = useState(false);
  const [logon_cookie_data, setLogon_cookie_data] = useState(cookies.get("haveLogon"));
  const [isMobileView, setIsMobileView] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    return window.innerWidth <= 890;
  });
  const [hideMobileHeader, setHideMobileHeader] = useState(false);
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);
  const lastScrollYRef = useRef(0);

  useLocationChange((loc: any) => {
    if (loc.pathname.includes("activateClient") || loc.pathname.includes("register")) setNeedClientActivation(true);
    else setNeedClientActivation(false);
  });

  useEffect(() => {
    if (cookies.get("haveLogon")) setIsLogedIn(true);
    else setIsLogedIn(false);
  }, [location, logon_cookie_data]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const handleResize = () => {
      const isMobile = window.innerWidth <= 890;
      setIsMobileView(isMobile);
      if (!isMobile) {
        setHideMobileHeader(false);
        setShowScrollTopButton(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || !isMobileView) {
      lastScrollYRef.current = 0;
      return;
    }

    const SCROLL_HIDE_THRESHOLD = 120;
    const SCROLL_BUTTON_THRESHOLD = 240;
    const MIN_SCROLL_DELTA = 6;

    lastScrollYRef.current = window.pageYOffset || window.scrollY || 0;

    const handleScroll = () => {
      const currentScroll = window.pageYOffset || window.scrollY || 0;
      const lastScroll = lastScrollYRef.current;
      const scrollDelta = currentScroll - lastScroll;
      const isScrollingDown = scrollDelta > MIN_SCROLL_DELTA;

      setHideMobileHeader((prev) => {
        if (currentScroll <= SCROLL_HIDE_THRESHOLD) {
          return false;
        }
        if (isScrollingDown && currentScroll > SCROLL_HIDE_THRESHOLD) {
          return true;
        }
        return prev;
      });

      setShowScrollTopButton(currentScroll > SCROLL_BUTTON_THRESHOLD);
      lastScrollYRef.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobileView]);

  const scrollToCenter = (el: any) => el.scrollIntoView({ behavior: 'smooth', block: 'start' });

  const handleScrollToTop = () => {
    if (typeof window === "undefined") {
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    setHideMobileHeader(false);
  };

  // Desktop navigation links, grouped into the two rows shown in the header.
  const desktopTopNavLinks = [
    {
      key: "cse",
      label: "Cosmic Succubus Evolution",
      to: "/cse_game#about",
    },
    {
      key: "secretary",
      label: "Secretary Assistant",
      to: "/secretary#top",
    },
    {
      key: "changelog",
      label: "Changelog",
      to: "/changelog#top",
    },
  ];

  const desktopBottomNavLinks = [
    {
      key: "download",
      label: "Play-Free-Now",
      to: "/#download",
    },
    {
      key: "patreon",
      label: "Patreon",
      to: "/crowdfund#about",
    },
    {
      key: "curation",
      label: "Curation",
      to: "/curation#top",
    },
    {
      key: "faq",
      label: "FAQ",
      to: "/faq#top",
    },
    {
      key: "blog",
      label: "Blog",
      to: "/blog#top",
    },
    {
      key: "login",
      label: "Login",
      to: "/cloudlogin",
    },
  ];

  // Mobile navigation links (excludes download since it's not useful on mobile).
  const mobilePrimaryLinks = [
    {
      key: "cse",
      label: "Cosmic Succubus Evolution",
      to: "/cse_game#about",
    },
    {
      key: "secretary",
      label: "Secretary Assistant",
      to: "/secretary#top",
    },
  ];

  const mobileChangelogBlogLinks = [
    {
      key: "changelog",
      label: "Changelog",
      to: "/changelog#top",
    },
    {
      key: "blog",
      label: "Blog",
      to: "/blog#top",
    },
  ];

  const mobilePatreonLoginLinks = [
    {
      key: "patreon",
      label: "Patreon",
      to: "/crowdfund#about",
    },
    {
      key: "login",
      label: "Login",
      to: "/cloudlogin",
    },
  ];

  const mobileSplitLinks = [
    {
      key: "faq",
      label: "FAQ",
      to: "/faq#top",
    },
    {
      key: "curation",
      label: "Curation",
      to: "/curation#top",
    },
  ];

  const forumHref = `https://${rillmentConfig.RG_HOSTNAME}/forum`;

  const AuthControls = () => {
    if (!rillmentConfig.PATREON_LOGIN_ENABLED) {
      return null;
    }

    if (isLogedIn) {
      return (
        <Dropdown overlay={profilemenu}>
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      );
    }

    if (needClientActivation) {
      return null;
    }

    return (
      <PatreonButon onClick={doPatreonLogin}>
        <a><img src={patreon_img} width="180px" alt="Patreon login"/></a>
      </PatreonButon>
    );
  };

  const doPatreonLogin = async () => {
    if (!rillmentConfig.PATREON_LOGIN_ENABLED) {
      notification.info({ message: 'Patreon disabled', description: 'Patreon login is currently disabled.', duration: 3 });
      return;
    }

    sessionStorage.removeItem("redirect_activateclient_done");
    sessionStorage.removeItem("redirect_activateclient");

    try {
      const res = await axios.post('api/prelogin', { AuthToken: "" }, { withCredentials: true });
      if (res.status === 201 || res.status === 200) {
        sessionStorage.setItem("prelogincsrf_token", res.data.csrf_token);
        const redirect_url = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=CY70WJDw7t4QWS47K3zONEb4dLm0dnUaptAfcZPJ31lhDfW_I-E1Vi3wfn8Qnp6I&redirect_uri=https://${rillmentConfig.RG_HOSTNAME}/portal/login&scope=identity+campaigns+identity.memberships+identity%5Bemail%5D&state=${res.data.session_id}`;
        window.location.replace(redirect_url);
      }
    } catch (error) {
      notification.error({ message: 'Login Error', description: String(error), duration: 10, placement: 'top' });
    }
  };

  const MenuItem = () => (
    <>
      <NavFlexContainer>
        {desktopTopNavLinks.map(({ key, label, to }) => (
          <CustomNavLinkSmall key={key}>
            <Link to={to} scroll={scrollToCenter}>{label}</Link>
          </CustomNavLinkSmall>
        ))}
      </NavFlexContainer>
      <NavFlexContainer>
        {desktopBottomNavLinks.map(({ key, label, to }) => (
          <CustomNavLinkSmall key={key}>
            <Link to={to} scroll={scrollToCenter}>{label}</Link>
          </CustomNavLinkSmall>
        ))}
        {rillmentConfig.PATREON_LOGIN_ENABLED && (
          <CustomNavLinkSmall key="forums">
            <a href={forumHref}>Forums</a>
          </CustomNavLinkSmall>
        )}
      </NavFlexContainer>
    </>
  );

  const MobileNavigation = () => (
    <MobileMenuWrapper>
      {mobilePrimaryLinks.map(({ key, label, to }) => (
        <MobileNavButton key={key} to={to} scroll={scrollToCenter}>
          {label}
        </MobileNavButton>
      ))}
      <MobileSplitRow>
        {mobileChangelogBlogLinks.map(({ key, label, to }) => (
          <MobileSplitButton key={key} to={to} scroll={scrollToCenter}>
            {label}
          </MobileSplitButton>
        ))}
      </MobileSplitRow>
      <MobileSplitRow>
        {mobilePatreonLoginLinks.map(({ key, label, to }) => (
          <MobileSplitButton key={key} to={to} scroll={scrollToCenter}>
            {label}
          </MobileSplitButton>
        ))}
      </MobileSplitRow>
      <MobileSplitRow>
        {mobileSplitLinks.map(({ key, label, to }) => (
          <MobileSplitButton key={key} to={to} scroll={scrollToCenter}>
            {label}
          </MobileSplitButton>
        ))}
      </MobileSplitRow>
      {rillmentConfig.PATREON_LOGIN_ENABLED && (
        <MobileNavExternal key="forums" href={forumHref}>
          Forums
        </MobileNavExternal>
      )}
    </MobileMenuWrapper>
  );

  return (
    <>
      <HeaderSection $hidden={isMobileView && hideMobileHeader}>
        <Container>
        <Row justify="space-between" align="middle" gutter={[16, 12]}>
          <Col xs={6} sm={4} md={3} lg={2} xl={2}>
            <LogoAndRSSWrapper>
              <LogoContainer to="/#about" scroll={scrollToCenter} aria-label="homepage">
                <SvgIcon src={logo_img} width="46px" height="76px" alt="Cosmic Succubus Evolution logo" />
              </LogoContainer>
              <MobileRSSWrapper>
                <RSSLink href="/rss.xml" aria-label="RSS Feed" title="RSS Feed">
                  <img src={rss_icon} alt="RSS Feed" />
                </RSSLink>
              </MobileRSSWrapper>
            </LogoAndRSSWrapper>
          </Col>

          <Col xs={18} sm={0} md={0} lg={0} xl={0}>
            <MobileNavigation />
            <div style={{ marginTop: "0.75rem", display: "flex", justifyContent: "flex-end" }}>
              <AuthControls />
            </div>
          </Col>

          <Col xs={0} sm={12} md={12} lg={13} xl={13}>
            <NotHidden>
              <MenuItem />
            </NotHidden>
          </Col>

          <Col xs={0} sm={2} md={2} lg={1} xl={1}>
            <DesktopRSSWrapper>
              <RSSLink href="/rss.xml" aria-label="RSS Feed" title="RSS Feed">
                <img src={rss_icon} alt="RSS Feed" />
              </RSSLink>
            </DesktopRSSWrapper>
          </Col>

          <Col xs={0} sm={6} md={7} lg={8} xl={8} style={{ textAlign: 'right' }}>
            <AuthControls />
          </Col>
        </Row>
        </Container>
      </HeaderSection>
      {isMobileView && showScrollTopButton && (
        <ScrollTopButton type="button" onClick={handleScrollToTop} aria-label="Back to top">
          <UpOutlined />
        </ScrollTopButton>
      )}
    </>
  );
};

export default withTranslation()(Header);
    // rerender logon if suddenly logged out
